import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
const NAV_LINKS = [{
  label: 'How It Works',
  to: '/#how-it-works'
}, {
  label: 'Dispatch',
  to: '/dispatch-services'
}, {
  label: 'Back Office',
  to: '/compliance-back-office-support'
}, {
  label: 'Lease On',
  to: '/lease-on-with-fsg'
}, {
  label: 'FAQ',
  to: '/faq'
}, {
  label: 'Contact',
  to: '/contact'
}];
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const goTo = (to: string) => {
    setIsMobileMenuOpen(false);
    if (to.startsWith('/#')) {
      const hash = to.slice(1);
      if (location.pathname === '/') {
        const target = document.querySelector(hash);
        if (target) {
          const offset = target.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({
            top: offset,
            behavior: 'smooth'
          });
        }
      } else {
        navigate('/' + hash);
      }
    } else {
      navigate(to);
    }
  };
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-navy/95 backdrop-blur-md shadow-lg py-2.5' : 'bg-navy py-4'}`} data-id="element-236">
        <div className="container-custom" data-id="element-237">
          <div className="flex items-center justify-between" data-id="element-238">
            <Link to="/" className="flex-shrink-0 z-50 flex items-center -my-2" data-id="element-239">
              <img src="https://images.squarespace-cdn.com/content/v1/6983a647318f183e844ca503/e2a2c4ee-2ab0-4982-9580-c994819db0b2/FSGTrans%2BTrans.png" alt="FSG Transport" className="h-auto w-auto max-h-[52px] md:max-h-[64px] lg:max-h-[76px] object-contain" data-id="element-240" />
            </Link>

            {/* Desktop Nav */}
            <nav className="hidden lg:flex items-center gap-5 xl:gap-7" data-id="element-241">
              {NAV_LINKS.map(link => <button key={link.label} onClick={() => goTo(link.to)} className="text-sm font-semibold text-off-white/80 hover:text-white transition-colors whitespace-nowrap" data-id="element-242">
                  {link.label}
                </button>)}
            </nav>

            {/* Desktop Actions */}
            <div className="hidden lg:flex items-center gap-4 xl:gap-5" data-id="element-243">
              <a href="tel:2346028424" className="flex items-center gap-2 text-white hover:text-red-400 transition-colors text-sm font-bold whitespace-nowrap" data-id="element-244">
                <Phone className="w-4 h-4 shrink-0" data-id="element-245" />
                234-602-8424
              </a>
              <Link to="/lease-on-with-fsg" className="btn-primary whitespace-nowrap" data-id="element-246">
                Apply to Lease On
              </Link>
            </div>

            {/* Mobile Menu Toggle */}
            <button className="lg:hidden z-50 text-white p-2 -mr-2 focus:outline-none focus:ring-2 focus:ring-white/50 rounded-sm" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" aria-expanded={isMobileMenuOpen} aria-controls="mobile-menu" data-id="element-247">
              {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-248" /> : <Menu className="w-6 h-6" data-id="element-249" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu Overlay */}
        <div id="mobile-menu" className={`fixed inset-0 bg-navy z-40 transition-transform duration-300 ease-in-out lg:hidden ${isMobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}`} style={{
        top: '0',
        paddingTop: '80px'
      }} data-id="element-250">
          <div className="flex flex-col h-full px-6 pb-24 overflow-y-auto" data-id="element-251">
            <nav className="flex flex-col gap-5 mt-8" data-id="element-252">
              {NAV_LINKS.map(link => <button key={link.label} onClick={() => goTo(link.to)} className="text-left text-xl font-bold text-white uppercase tracking-wider border-b border-white/10 pb-4" data-id="element-253">
                  {link.label}
                </button>)}
            </nav>
            <div className="mt-10 flex flex-col gap-4" data-id="element-254">
              <Link to="/lease-on-with-fsg" onClick={() => setIsMobileMenuOpen(false)} className="btn-primary w-full text-center py-4 text-lg" data-id="element-255">
                Apply to Lease On
              </Link>
              <a href="tel:2346028424" className="flex items-center justify-center gap-2 text-white text-lg font-semibold border border-white/20 py-4 rounded-sm" data-id="element-256">
                <Phone className="w-5 h-5" data-id="element-257" />
                234-602-8424
              </a>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Sticky Bottom CTA */}
      <div className={`lg:hidden fixed bottom-0 left-0 right-0 bg-navy border-t border-white/10 p-3 flex gap-3 shadow-[0_-4px_20px_rgba(0,0,0,0.3)] transition-opacity duration-300 ${isMobileMenuOpen ? 'z-30 opacity-0 pointer-events-none' : 'z-40 opacity-100'}`} data-id="element-258">
        <a href="tel:2346028424" className="flex-1 flex items-center justify-center gap-2 bg-white/10 text-white font-bold text-sm py-3 rounded-sm uppercase tracking-wider" data-id="element-259">
          <Phone className="w-4 h-4" data-id="element-260" />
          Call FSG
        </a>
        <Link to="/lease-on-with-fsg" className="flex-[2] btn-primary py-3 text-sm" onClick={() => setIsMobileMenuOpen(false)} data-id="element-261">
          Apply to Lease On
        </Link>
      </div>
    </>;
}